import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';

function Login({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      if (onLoginSuccess) onLoginSuccess();
    } catch (err) {
      setError('Login fehlgeschlagen. Bitte überprüfe deine Eingaben.');
      console.error(err);
    }
  };

  return (
    <div style={{
      height: '100vh',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'linear-gradient(to bottom, #4facfe 0%, #00f2fe 100%)'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '40px',
        width: '100%',
        maxWidth: '450px',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
        textAlign: 'center'
      }}>
        <h1 style={{
          color: '#1e3a8a',
          fontSize: '28px',
          marginBottom: '30px',
          fontWeight: 'bold'
        }}>Admin Login</h1>
        
        {error && <p style={{ 
          color: '#e11d48', 
          backgroundColor: '#ffe4e6',
          padding: '10px', 
          borderRadius: '4px', 
          marginBottom: '20px' 
        }}>{error}</p>}
        
        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '20px', textAlign: 'left' }}>
            <div style={{ 
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#f3f4f6',
              borderRadius: '6px',
              padding: '5px 15px'
            }}>
              <span style={{ marginRight: '10px', color: '#9ca3af' }}>📧</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="E-Mail"
                style={{ 
                  width: '100%', 
                  padding: '12px 0',
                  border: 'none',
                  backgroundColor: 'transparent',
                  outline: 'none',
                  fontSize: '16px'
                }}
                required
              />
            </div>
          </div>
          
          <div style={{ marginBottom: '30px', textAlign: 'left' }}>
            <div style={{ 
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#f3f4f6',
              borderRadius: '6px',
              padding: '5px 15px'
            }}>
              <span style={{ marginRight: '10px', color: '#9ca3af' }}>🔒</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Passwort"
                style={{ 
                  width: '100%', 
                  padding: '12px 0',
                  border: 'none',
                  backgroundColor: 'transparent',
                  outline: 'none',
                  fontSize: '16px'
                }}
                required
              />
            </div>
          </div>
          
          <button 
            type="submit"
            style={{ 
              width: '100%',
              padding: '14px',
              borderRadius: '30px',
              border: 'none',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold',
              color: 'white',
              background: 'linear-gradient(to right, #1e3a8a, #3b82f6)',
              transition: 'transform 0.2s ease',
              marginBottom: '15px'
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            ANMELDEN
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;